export const FEEDBACK_FIELDS = {
    feedbackType: {
        label: "Feedback Type",
        required: true,
    },

    featureName: {
        label: "Feature / Module",
        required: true,
    },

    comments: {
        label: "Comments",
        type: "ALPHABET",
        required: true,
        minLength: 20,
        maxLength: 2000,
    },
};